import script from "./resultSuggestionsUpper.vue?vue&type=script&setup=true&lang=ts"
export * from "./resultSuggestionsUpper.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__